var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"payment"},[_c('div',{staticClass:"card"},[_c('CustomIcon',{attrs:{"name":_vm.content.image}}),_c('h3',[_vm._v(_vm._s(_vm.content.title))]),_c('p',[_vm._v(_vm._s(_vm.descriptionMessage))]),_c('CustomButton',{attrs:{"variation":"primary","onClick":_vm.action}},[_vm._v("Continue")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }